module.exports = __webpack_public_path__ + "static/media/2.fa5d9345.jpg";